<template>
  <div id="Operation">
    <b-row class="h-100 mh-100 mx-0" style="overflow-y: auto">
      <b-container fluid class="h-100 mh-100">
        <b-row class="m-3">
          <b-col xl="12" lg="12" md="12" sm="12" class="title">
            <div
              class="text-left pl-3"
              style="border-bottom: 4px solid #707070; color: #707070"
            >
              機台狀況
            </div>
            <deviceStatus :deviceStatusData="deviceStatusData"></deviceStatus>
            <!-- <chart
              :chartId="MachineChart.name.chartId"
              :chartName="MachineChart.name.chartName"
              :styleGroup="MachineChart.styleGroup"
              :chartData="MachineChart.options[0].value.data"
            ></chart> -->
          </b-col>
        </b-row>
        <b-row class="m-3">
          <b-col
            xl="4"
            lg="4"
            md="12"
            sm="12"
            class="pb-3"
            :class="{
              'pl-0': window_innerWidth >= 992,
              'px-0': window_innerWidth <= 992,
            }"
          >
            <div class="title h-100">
              <div
                class="text-left pl-3"
                style="border-bottom: 4px solid #707070; color: #707070"
              >
                邏輯CPU使用率
              </div>
              <chart
                :chartId="CPUChart.name.chartId"
                :chartName="CPUChart.name.chartName"
                :styleGroup="CPUChart.styleGroup"
                :chartData="CPUChart.options[0].value.data"
              ></chart>
            </div>
          </b-col>
          <b-col xl="4" lg="4" md="12" sm="12" class="px-0 pb-3">
            <div class="title h-100">
              <div
                class="text-left pl-3"
                style="border-bottom: 4px solid #707070; color: #707070"
              >
                實體RAM使用概況
              </div>
              <chart
                :chartId="'EntityRAM'"
                :chartName="EntityRAM.name.chartName"
                :styleGroup="EntityRAM.styleGroup"
                :chartData="EntityRAM.options[0].value.data"
              ></chart>
              <div
                class="text-left pl-3"
                style="border-bottom: 4px solid #707070; color: #707070"
              >
                虛擬RAM使用概況
              </div>
              <chart
                :chartId="'SwapRAM'"
                :chartName="SwapRAM.name.chartName"
                :styleGroup="SwapRAM.styleGroup"
                :chartData="SwapRAM.options[0].value.data"
              ></chart>
            </div>
          </b-col>
          <b-col
            xl="4"
            lg="4"
            md="12"
            sm="12"
            class="pb-3"
            :class="{
              'pr-0': window_innerWidth >= 992,
              'px-0': window_innerWidth <= 992,
            }"
          >
            <div class="title h-100">
              <div
                class="text-left pl-3"
                style="border-bottom: 4px solid #707070; color: #707070"
              >
                DISK容量
              </div>
              <chart
                :chartId="'DISK'"
                :chartName="DISKChart.name.chartName"
                :styleGroup="DISKChart.styleGroup"
                :chartData="DISKChart.options[0].value.data"
              ></chart>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import chart from "@/components/chart.vue";
import deviceStatus from "@/components/deviceStatus.vue";
export default {
  name: "Operation",
  data() {
    let vm = this;
    return {
      table_notfound: true,
      options: [],
      selected: null,
      deviceStatusData: [],
      MachineChart: {
        name: {
          chartId: "Machine", //英文
          chartName: "Machine狀態", //中文
        },
        options: [
          {
            text: "Machine用量", //中文
            value: {
              name: "Machine", //英文
              data: {
                senTime: [],
                senData: {},
                senType: "Machine", //圖表類型
              },
            },
          },
        ],
        styleGroup: { width: "100%", height: "200px" },
      },
      CPUChart: {
        name: {
          chartId: "cpu_usage", //英文
          chartName: "CPU使用率", //中文
        },
        options: [
          {
            text: "CPU使用率", //中文
            value: {
              name: "CPU", //英文
              data: {
                yAxisData: [],
                seriesData: [],
                senType: "CPU", //圖表類型
              },
            },
          },
        ],
        styleGroup: { width: "95%", height: "400px" },
      },
      DISKChart: {
        name: {
          chartId: "DISK", //英文
          chartName: "DISK用量", //中文
        },
        options: [
          {
            text: "DISK用量", //中文
            value: {
              name: "DISK", //英文
              data: {
                senTime: [],
                senData: {},
                dataset: {},
                senType: "DISK", //圖表類型
              },
            },
          },
        ],
        styleGroup: { width: "100%", height: "400px" },
      },
      EntityRAM: {
        name: {
          chartId: "EntityRAM", //英文
          chartName: "實體RAM使用概況", //中文
        },
        options: [
          {
            text: "實體RAM使用概況", //中文
            value: {
              name: "EntityRAM", //英文
              data: {
                yAxisData: ["Mem"],
                legendData: [
                  {
                    name: "used",
                    icon: "circle",
                    color: "#3C6E65",
                  },
                  {
                    name: "buffers",
                    icon: "circle",
                    color: "#4B8C80",
                  },
                  {
                    name: "cached",
                    icon: "circle",
                    color: "#6FA399",
                  },
                  {
                    name: "shared",
                    icon: "circle",
                    color: "#93BAB3",
                  },
                  {
                    name: "available",
                    icon: "circle",
                    color: "#B7D1CC",
                  },
                ],
                seriesData: [],
                senType: "EntityRAM", //圖表類型
              },
            },
          },
        ],
        styleGroup: { width: "100%", height: "200px" },
      },
      SwapRAM: {
        name: {
          chartId: "SwapRAM", //英文
          chartName: "虛擬RAM使用概況", //中文
        },
        options: [
          {
            text: "虛擬RAM使用概況", //中文
            value: {
              name: "SwapRAM", //英文
              data: {
                yAxisData: ["Swap"],
                legendData: [
                  {
                    name: "used",
                    icon: "circle",
                    color: "#6FA399",
                  },
                  {
                    name: "free",
                    icon: "circle",
                    color: "#cccccc",
                  },
                ],
                seriesData: [],
                senType: "SwapRAM", //圖表類型
              },
            },
          },
        ],
        styleGroup: { width: "100%", height: "200px" },
      },
      detail_items: [],
      detail_height: "",
      timer_get_cpu: null,
      window_innerWidth: "",
      timer_getServerProcessesUsage: "",
    };
  },
  created() {
    this.change_selectPage("operation");
    this.change_selectPageName(this.pageName.operation);
    // this._getServerProcessesUsage();
    this.getServerProcessesUsage();
    this._onResizeOperation();
    window.addEventListener("resize", this._onResizeOperation);
  },
  mounted() {
    // this.timer_get_cpu = setInterval(() => {
    //   this._getServerProcessesUsage();
    // }, 10000);
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      // system: "apidetail/get_system",
    }),
  },
  components: {
    chart,
    deviceStatus,
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      axiosGetAction: "commonaxios/axiosGetAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      setSetTimeOutAlertMsg: "alertmodal/set_setTimeOutAlertMsg",
      toggleSetTimeOutAlertModal: "alertmodal/toggle_settimeout_alertModal",
    }),

    getServerProcessesUsage() {
      let vm = this;
      if (vm.selectPage != "operation") {
        return;
      }
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      vm.query_time = new Date();
      vm.axiosAction(params).then(() => {
        // vm.trigger_loadScreenModal();
        vm.searching = false;
        var result = vm.axiosResult;
        console.log(result);
        if (result.Response == "ok") {
          let result_data = result["QueryTableData"];
          // console.log(vm.deviceStatusData);
          // console.log(result_data[0]["device_data"]);
          vm.deviceStatusData = result_data[0]["device_data"];
          let server_data = result_data[0]["server_data"];

          // vm.CPUChart.options[0].value.data.yAxisData = Array.from(
          //   Array(server_data["cpu_usage"].length).keys(),
          //   (x) => "core" + Number(x + 1)
          // );

          // vm.CPUChart.options[0].value.data.seriesData =
          //   server_data["cpu_usage"];

          //CPU
          vm.CPUChart.options[0].value.data.yAxisData = Object.keys(
            server_data["cpu_usage"]
          );

          vm.CPUChart.options[0].value.data.seriesData = Object.values(
            server_data["cpu_usage"]
          );

          //RAM
          vm.EntityRAM.options[0].value.data.seriesData = [];
          vm.EntityRAM.options[0].value.data.legendData.map((element) => {
            vm.EntityRAM.options[0].value.data.seriesData.push({
              name: element.name,
              type: "bar",
              stack: "total",
              color: element.color,
              label: {
                show: true,
              },
              emphasis: {
                focus: "series",
              },
              data: [server_data["memory_virtual"][element.name]],
            });
          });
          console.log(vm.EntityRAM.options[0].value.data.seriesData);
          vm.SwapRAM.options[0].value.data.seriesData = [];
          vm.SwapRAM.options[0].value.data.legendData.map((element) => {
            vm.SwapRAM.options[0].value.data.seriesData.push({
              name: element.name,
              type: "bar",
              stack: "total",
              color: element.color,
              label: {
                show: true,
              },
              emphasis: {
                focus: "series",
              },
              data: [server_data["memory_swap"][element.name]],
            });
          });

          //DISK
          let disk_color = [
            "#407A6F",
            "#4B8C80",
            "#6FA399",
            "#93BAB3",
            "#B7D1CC",
            "#DBE8E6",
          ]; //資料顏色
          let dataset = {
            source: [
              [
                "title",
                "color",
                "used_value",
                "free_value",
                "used_percent",
                "free_percent",
              ],
            ],
          };
          let disk_partition_usage_key = Object.keys(
            server_data["disk_partition_usage"]
          );
          vm.DISKChart.options[0].value.data.seriesData = [];
          disk_partition_usage_key.forEach((element, index) => {
            dataset.source.push([
              element,
              disk_color[index],
              server_data["disk_partition_usage"][element]["used"],
              server_data["disk_partition_usage"][element]["free"],
              server_data["disk_partition_usage"][element]["percent"],
              100 - server_data["disk_partition_usage"][element]["percent"],
            ]);
          });
          vm.DISKChart.options[0].value.data.dataset = {};
          vm.DISKChart.options[0].value.data.dataset = dataset;
          vm.DISKChart.options[0].value.data.seriesData = [];
          vm.DISKChart.options[0].value.data.seriesData = [
            {
              type: "bar",
              emphasis: {
                focus: "series",
              },
              itemStyle: {
                color: function (param) {
                  return param.value[1] || "#407A6F";
                },
              },
              name: "used",
              encode: {
                // Map the "value" column to X axis.
                x: "used_percent",
                // Map the "title" column to Y axis
                y: "title",
              },
              stack: "total",
              label: {
                show: true,
                formatter: function (param) {
                  return param.value[2];
                },
              },
            },
            {
              type: "bar",
              emphasis: {
                focus: "series",
              },
              itemStyle: {
                color: "#cccccc",
              },
              name: "free",
              encode: {
                // Map the "value" column to X axis.
                x: "free_percent",
                // Map the "title" column to Y axis
                y: "title",
              },
              stack: "total",
              label: {
                show: true,
                formatter: function (param) {
                  return param.value[3];
                },
              },
            },
          ];
        }
        if (vm.query_time != null) {
          vm.query_time = null;
          setTimeout(function () {
            vm.getServerProcessesUsage();
          }, 2000);
        }
      });
    },

    _getServerProcessesUsage() {
      let vm = this;
      var params = {};
      params["url"] = "/api/PaaS/1.0/sys/Monitor/Server/Processes/Usage";

      vm.axiosGetAction(params).then(() => {
        var result = vm.axiosResult;
        console.log(result);
        if (result.status != 200) {
          vm.setSetTimeOutAlertMsg(result.data);
          vm.toggleSetTimeOutAlertModal();
          return;
        }
        if (result.data["Response"] === "ok") {
          console.log(result.data["Information"]["cpu_usage"]);
          console.log(
            Array.from(
              Array(result.data["Information"]["cpu_usage"].length).keys(),
              (x) => x + 1
            )
          );
          //https://stackoverflow.com/questions/36947847/how-to-generate-range-of-numbers-from-0-to-n-in-es2015-only

          //CPU
          vm.CPUChart.options[0].value.data.yAxisData = Array.from(
            Array(result.data["Information"]["cpu_usage"].length).keys(),
            (x) => "core" + Number(x + 1)
          );

          vm.CPUChart.options[0].value.data.seriesData =
            result.data["Information"]["cpu_usage"];

          //RAM
          vm.EntityRAM.options[0].value.data.seriesData = [];
          vm.EntityRAM.options[0].value.data.legendData.map((element) => {
            vm.EntityRAM.options[0].value.data.seriesData.push({
              name: element.name,
              type: "bar",
              stack: "total",
              color: element.color,
              label: {
                show: true,
              },
              emphasis: {
                focus: "series",
              },
              data: [
                result.data["Information"]["memory_virtual"][element.name],
              ],
            });
          });
          console.log(vm.EntityRAM.options[0].value.data.seriesData);
          vm.SwapRAM.options[0].value.data.seriesData = [];
          vm.SwapRAM.options[0].value.data.legendData.map((element) => {
            vm.SwapRAM.options[0].value.data.seriesData.push({
              name: element.name,
              type: "bar",
              stack: "total",
              color: element.color,
              label: {
                show: true,
              },
              emphasis: {
                focus: "series",
              },
              data: [result.data["Information"]["memory_swap"][element.name]],
            });
          });

          //DISK
          let disk_color = [
            "#407A6F",
            "#4B8C80",
            "#6FA399",
            "#93BAB3",
            "#B7D1CC",
            "#DBE8E6",
          ]; //資料顏色
          let dataset = {
            source: [
              [
                "title",
                "color",
                "used_value",
                "free_value",
                "used_percent",
                "free_percent",
              ],
            ],
          };
          // let seriesData_free = [];
          let disk_partition_usage_key = Object.keys(
            result.data["Information"]["disk_partition_usage"]
          );
          vm.DISKChart.options[0].value.data.seriesData = [];
          disk_partition_usage_key.forEach((element, index) => {
            dataset.source.push([
              element,
              disk_color[index],
              result.data["Information"]["disk_partition_usage"][element][
                "used"
              ],
              result.data["Information"]["disk_partition_usage"][element][
                "free"
              ],
              result.data["Information"]["disk_partition_usage"][element][
                "percent"
              ],
              100 -
                result.data["Information"]["disk_partition_usage"][element][
                  "percent"
                ],
            ]);
          });
          vm.DISKChart.options[0].value.data.dataset = {};
          vm.DISKChart.options[0].value.data.dataset = dataset;
          vm.DISKChart.options[0].value.data.seriesData = [];
          vm.DISKChart.options[0].value.data.seriesData = [
            {
              type: "bar",
              emphasis: {
                focus: "series",
              },
              itemStyle: {
                color: function (param) {
                  return param.value[1] || "#407A6F";
                },
              },
              name: "used",
              encode: {
                // Map the "value" column to X axis.
                x: "used_percent",
                // Map the "title" column to Y axis
                y: "title",
              },
              stack: "total",
              label: {
                show: true,
                formatter: function (param) {
                  return param.value[2];
                },
              },
            },
            {
              type: "bar",
              emphasis: {
                focus: "series",
              },
              itemStyle: {
                color: "#cccccc",
              },
              name: "free",
              encode: {
                // Map the "value" column to X axis.
                x: "free_percent",
                // Map the "title" column to Y axis
                y: "title",
              },
              stack: "total",
              label: {
                show: true,
                formatter: function (param) {
                  return param.value[3];
                },
              },
              // type: "bar",
              // itemStyle: {
              //   color: "#cccccc",
              // },
              // name: "free",
              // stack: "total",
              // data: seriesData_free,
              // label: {
              //   show: true,
              //   formatter: function (param) {
              //     console.log(param);
              //     return param.value[3]
              //   },
              // },
            },
          ];
        } else {
          vm.setSetTimeOutAlertMsg(result.data["Response"]);
          vm.toggleSetTimeOutAlertModal();
        }
      });
    },

    _onResizeOperation() {
      let vm = this;
      vm.window_innerWidth = window.innerWidth;
    },

    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  //調用router守衛，在離開時將this_click reset
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer_get_cpu);
    this.reset([]);
    next();
  },

  destroyed() {
    window.removeEventListener("resize",this._onResizeOperation);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  color: #40576e;
  font-weight: bold;
  font-size: 24px;
  box-shadow: 0 2px 15px rgb(0 0 0 / 5%), 0 1px 6px rgb(0 0 0 / 5%);
  /* padding-right: 1px !important; */
  padding: 1rem 0.5rem 0 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Operation.vue